import type { DocNavItem } from './model.ts'
import { helpSolutions } from './catalog.mjs'

const groupOrder = ['Bắt đầu', 'Giải pháp Két Việt', 'Giữ khách & tăng doanh thu', 'Công việc chăm sóc', 'CRM & bán hàng', 'Hồ sơ sử dụng', 'Vận hành quảng cáo', 'Đo lường & hiệu quả', 'Tối ưu quảng cáo', 'Bảo vệ quảng cáo', 'Quản lý & cấu hình', 'Tài liệu liên quan']

// The sidebar and all-topic index share grouping and source order.
export function groupTopics(items: DocNavItem[], includeSolutions = false) {
  const grouped = items.map(item => includeSolutions && helpSolutions.some(solution => solution.slug === item.slug)
    ? { ...item, group: 'Giải pháp Két Việt' } : item)
  return [...new Set(grouped.map(item => item.group))]
    .sort((a, b) => groupOrder.indexOf(a) - groupOrder.indexOf(b))
    .map(group => ({ title: group, items: grouped.filter(item => item.group === group) }))
}

// A solution owns its landing page and descendants; root pages show the catalog.
export function solutionForRoute(route: string) {
  return helpSolutions.find(solution => route.startsWith(`/help/${solution.slug}/`))
}
export function solutionTopics(items: DocNavItem[], route: string) {
  const solution = solutionForRoute(route)
  return items.filter(item => solution ? item.route.startsWith(`/help/${solution.slug}/`) : !item.slug.includes('/'))
}
